export const ESCAPE = "Escape";
export const SPACE = " ";
export const ENTER = "Enter";
